/* eslint no-param-reassign: 0 */
/**
 * Test if a DOM element has a certain CSS class
 * @param {string} element The DOM element
 * @param {string} className The CSS class you want to test
 * @return {boolean} true or false
 */
function hasClass(element, className) {
  return element.classList
    ? element.classList.contains(className)
    : new RegExp(`\\b${className}\\b`).test(element.className);
}

/**
 * Add a class to an DOM element
 * @param {string} element The DOM element
 * @param {string} className The CSS class you want to test
 */
function addClass(element, className) {
  if (element.classList) {
    element.classList.add(className);
  } else if (!hasClass(element, className)) {
    element.className += ` ${className}`;
  }
}

/**
 * Toggle a class to an DOM element
 * @param {string} element The DOM element
 * @param {string} className The CSS class you want to test
 */
function toggleClass(element, className, value) {
  if (element.classList) {
    element.classList.toggle(className, value);
  } else if (!hasClass(element, className)) {
    element.className += ` ${className}`;
  }
}

/**
 * Remove a class to an DOM element
 * @param {string} element The DOM element
 * @param {string} className The CSS class you want to test
 */
function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else {
    element.className = element.className.replace(new RegExp(`\\b${className}\\b`, 'g'), '');
  }
}

/**
 * Randomize function
 *
 * @param {number} min Min value
 * @param {number} max Max value
 * @param {number} intResult convert result to an integer
 */
function randomize(min, max, intResult) {
  if (typeof min !== 'number' && typeof max !== 'number') {
    min = 0;
    max = 1;
  }

  if (typeof max !== 'number') {
    max = min;
    min = 0;
  }

  let result = (min + Math.random()) * (max - min);

  if (intResult) {
    result = parseInt(result, 10);
  }

  return result;
}

export { randomize, hasClass, addClass, toggleClass, removeClass };
